import React from 'react'
import FloatingChatbot from './FloatingChatbot'
import EmbedChatbot from './EmbededChatbot'
import { IAgent } from '../../models/agent'
import { useParams } from 'react-router-dom';
import { useAgentContext } from '../../context/agent';
import { Stack } from 'react-bootstrap';


function WebDeployment() {
    const { agentId} = useParams();
    const {getAgentById} = useAgentContext();
    const agent = getAgentById(agentId || "");
  return (
    <Stack>
        { 
            agent && <div>
                <FloatingChatbot agent={agent}/>
                <EmbedChatbot agent={agent} />
            </div>
        }
        
    </Stack>
  )
}

export default WebDeployment